import { AnchorTitle } from "#components/ui/anchor-title"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "#components/ui/card"
import { Separator } from "#components/ui/separator"
import { Body, H3 } from "#components/ui/typography"
import { useI18n } from "#hooks/use-i18n"
import { DollarSign, Pencil, Plus, Trash2, UserRound } from "lucide-react"

export function PartnersHelp() {
  const { t } = useI18n()

  return (
    <div className="space-y-6">
      <div>
        <H3 className="mb-2">{t("pages.help.partners.overview.title")}</H3>
        <Body className="text-muted-foreground">
          {t("pages.help.partners.overview.description")}
        </Body>
      </div>

      <Card id="partners-table">
        <CardHeader>
          <CardTitle>{t("pages.help.partners.table.title")}</CardTitle>
          <CardDescription>{t("pages.help.partners.table.description")}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div>
            <Body className="font-semibold mb-2">
              {t("pages.help.partners.table.columns.title")}
            </Body>
            <Body className="text-muted-foreground text-sm">
              {t("pages.help.partners.table.columns.description")}
            </Body>
          </div>

          <Separator />

          <div>
            <Body className="font-semibold mb-2">
              {t("pages.help.partners.table.sorting.title")}
            </Body>
            <Body className="text-muted-foreground text-sm">
              {t("pages.help.partners.table.sorting.description")}
            </Body>
          </div>
        </CardContent>
      </Card>

      <Card id="partners-actions">
        <CardHeader>
          <CardTitle>
            <AnchorTitle id="partners-actions">
              {t("pages.help.partners.actions.title")}
            </AnchorTitle>
          </CardTitle>
          <CardDescription>{t("pages.help.partners.actions.description")}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="flex items-start gap-3">
            <Plus className="w-5 h-5 mt-0.5 text-primary flex-shrink-0" />
            <div className="flex-1">
              <Body className="font-semibold mb-1">
                {t("pages.help.partners.actions.add.title")}
              </Body>
              <Body className="text-muted-foreground text-sm">
                {t("pages.help.partners.actions.add.description")}
              </Body>
            </div>
          </div>

          <Separator />

          <div className="flex items-start gap-3">
            <Pencil className="w-5 h-5 mt-0.5 text-primary flex-shrink-0" />
            <div className="flex-1">
              <Body className="font-semibold mb-1">
                {t("pages.help.partners.actions.edit.title")}
              </Body>
              <Body className="text-muted-foreground text-sm">
                {t("pages.help.partners.actions.edit.description")}
              </Body>
            </div>
          </div>

          <Separator />

          <div className="flex items-start gap-3">
            <Trash2 className="w-5 h-5 mt-0.5 text-primary flex-shrink-0" />
            <div className="flex-1">
              <Body className="font-semibold mb-1">
                {t("pages.help.partners.actions.delete.title")}
              </Body>
              <Body className="text-muted-foreground text-sm">
                {t("pages.help.partners.actions.delete.description")}
              </Body>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card id="partners-form">
        <CardHeader>
          <CardTitle>
            <AnchorTitle id="partners-form">{t("pages.help.partners.form.title")}</AnchorTitle>
          </CardTitle>
          <CardDescription>{t("pages.help.partners.form.description")}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="flex items-start gap-3">
            <UserRound className="w-5 h-5 mt-0.5 text-primary flex-shrink-0" />
            <div className="flex-1">
              <Body className="font-semibold mb-1">
                {t("pages.help.partners.form.personalInfo.title")}
              </Body>
              <Body className="text-muted-foreground text-sm">
                {t("pages.help.partners.form.personalInfo.description")}
              </Body>
            </div>
          </div>

          <Separator />

          <div className="flex items-start gap-3">
            <DollarSign className="w-5 h-5 mt-0.5 text-primary flex-shrink-0" />
            <div className="flex-1">
              <Body className="font-semibold mb-1">
                {t("pages.help.partners.form.salary.title")}
              </Body>
              <Body className="text-muted-foreground text-sm">
                {t("pages.help.partners.form.salary.description")}
              </Body>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card id="partners-limits">
        <CardHeader>
          <CardTitle>
            <AnchorTitle id="partners-limits">{t("pages.help.partners.limits.title")}</AnchorTitle>
          </CardTitle>
          <CardDescription>{t("pages.help.partners.limits.description")}</CardDescription>
        </CardHeader>
        <CardContent>
          <Body className="text-muted-foreground text-sm">
            {t("pages.help.partners.limits.content")}
          </Body>
        </CardContent>
      </Card>

      <Card id="partners-privacy">
        <CardHeader>
          <CardTitle>
            <AnchorTitle id="partners-privacy">
              {t("pages.help.partners.privacy.title")}
            </AnchorTitle>
          </CardTitle>
          <CardDescription>{t("pages.help.partners.privacy.description")}</CardDescription>
        </CardHeader>
        <CardContent>
          <Body className="text-muted-foreground text-sm">
            {t("pages.help.partners.privacy.content")}
          </Body>
        </CardContent>
      </Card>

      <Card id="partners-permissions">
        <CardHeader>
          <CardTitle>
            <AnchorTitle id="partners-permissions">
              {t("pages.help.partners.permissions.title")}
            </AnchorTitle>
          </CardTitle>
          <CardDescription>{t("pages.help.partners.permissions.description")}</CardDescription>
        </CardHeader>
        <CardContent>
          <Body className="text-muted-foreground text-sm">
            {t("pages.help.partners.permissions.content")}
          </Body>
        </CardContent>
      </Card>
    </div>
  )
}
